import { render } from "./SettingItem.vue?vue&type=template&id=08e3b0df&scoped=true"
import script from "./SettingItem.vue?vue&type=script&lang=js"
export * from "./SettingItem.vue?vue&type=script&lang=js"

import "./SettingItem.vue?vue&type=style&index=0&id=08e3b0df&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08e3b0df"

export default script